import { render } from "./ListProducts.vue?vue&type=template&id=7b041f84&scoped=true"
import script from "./ListProducts.vue?vue&type=script&lang=js"
export * from "./ListProducts.vue?vue&type=script&lang=js"

import "./ListProducts.vue?vue&type=style&index=0&id=7b041f84&scoped=true&lang=css"

import exportComponent from "E:\\cymcorp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b041f84"]])

export default __exports__